import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import SvgUpArrowIcon from '../../svg/UpArrowIcon';
import { submitFkRepairRequest } from '../../../redux/actions/supportActions';
import { emptyText } from '../../shared/SharedInternationalizations';
import { useState } from 'react';
import FkRepairForm from './FkRepairForm';

export function UnconnectedFkRepair(props) {
  const [apiResults, setApiResults] = useState('')
  const backText = (
    <FormattedMessage
      id="fkRepair.backText"
      defaultMessage="Back to Database Tools"
      description="Link back to the users interface"
    />
  );

  function submitMessage(values) {
    //setApiResults('Loading...')
    props.dispatch(submitFkRepairRequest({
      message: values, 
      setStateFunc: setApiResults,
    }))
  }

  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">

        <div className="width-100 align-center flex-around margin-bottom-10">
          <Link
            className="link-text align-center"
            to="/support/db/"
            data-test="user-display-cancel-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </Link>
        </div>

        <div className="content-display__container content-display__container--column align-center">
          <FormattedMessage
            id="fkrepair.header"
            data-test="header-text"
            defaultMessage="Foreign Key Repair"
            description="The title for the page to edit a unit">
            {(txt) => (
              <h1
                className="no-margin text-deep-blue text-center"
                data-test="header-text-device">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <hr />
          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column"
              data-test="active-unit-container">
              <div
                className="content-display__column"
                data-test="active-unit-container">
                <div className="content-display__item-pill-container">
                  <div className="item-container__main-container">
                    <FkRepairForm onSubmit={submitMessage} />
                  </div>
                </div>
              </div>
              <div
                className="content-display__column"
                data-test="active-unit-container">
                <div className="content-display__item-pill-container">
                  <div className="item-container__main-container">
                    <div className="item-container__main-text text-large text-light">
                      <FormattedMessage
                        id="fkrepair.ToolReturnedText"
                        defaultMessage="Results"
                        description="Fk Repair tool"
                      />
                      <hr />
                    </div>
                    <div
                      className="item-container__secondary-text text-medium text-bold"
                      data-test="user-active-unit-link">
                      {apiResults ? (
                        <pre>{JSON.stringify(JSON.parse(apiResults), null, 2)}</pre>
                      ) : (
                        <span className="text-dimmed">{emptyText}</span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="width-100 align-center flex-around margin-bottom-10">
            <Link
              className="link-text align-center"
              to="/support/db/"
              data-test="user-display-cancel-link">
              <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
              {backText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {};
}

export default connect(mapStateToProps)(UnconnectedFkRepair);
